const typographyFormParamEquipModel = {
  true: 'Registration of New Equipment Type',
  false: 'Edit Equipment'
};

export default typographyFormParamEquipModel;
